import useUserStore from "@/stores/User";
import { CurrentUserContent } from "@/types/setting";
import {
  AdminRoleName,
  FinanceRoleName,
  ProductManagerRoleName,
} from "@/consts/Setting";

export const useIsFinancialManager = () => {
  const storedUser: CurrentUserContent = useUserStore((state) => state.user);

  return (
    storedUser?.roles?.some((role) => role.name === FinanceRoleName) ?? false
  );
};

export const useIsAdmin = () => {
  const storedUser: CurrentUserContent = useUserStore((state) => state.user);

  return (
    storedUser?.roles?.some((role) => role.name === AdminRoleName) ?? false
  );
};

export const useIsProductManager = () => {
  const storedUser: CurrentUserContent = useUserStore((state) => state.user);

  return (
    storedUser?.roles?.some((role) => role.name === ProductManagerRoleName) ?? false
  );
};

// 대체품 수정/삭제 권한 체크 (ProductManager만 허용)
export const useCanEditSubstituteProducts = () => {
  const isProductManager = useIsProductManager();

  return isProductManager;
};
